import { useState } from "react";
import { Send, Loader2 } from "lucide-react";
import { useChatStore } from "@/store/chatStore";
import { Button } from "@/components/ui/button";
import { cn } from "@/libs/utils";
import { toast } from "sonner";
import { useSendMessage } from "@/hooks/use-queries";
import { useAuthStore } from "@/store/authStore";

export function ChatInput() {
  const [message, setMessage] = useState("");
  const selectedRoomId  = useChatStore((state) => state.selectedRoomId);
  const selectedRoomSlug  = useChatStore((state) => state.selectedRoomSlug);
   const token = useAuthStore((state) => state.token);
  const { mutate: sendMessage, isPending, isSuccess } = useSendMessage();

  const handleSend = () => {
    if (!message.trim() || !selectedRoomId) return;
    if (message.length >= 100) {
      toast.error(
        "Message length is more than 100 characters. Please write less."
      );
      return;
    }

    sendMessage({ text_content: message, room_slug: selectedRoomSlug!, token: token || "" },{onSuccess:()=>setMessage("")});
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  if (!selectedRoomId) return null;

  return (
    <div className="p-4 border-t border-border">
      <div className="flex items-center gap-2 ">
        <div className="flex-1 relative">
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            onKeyDown={handleKeyPress}
            placeholder="Type a message..."
            rows={1}
            className={cn(
              "w-full px-4 py-2 rounded-full resize-none",
              "bg-muted",
              "border border-border",
              "text-foreground",
              "placeholder:text-muted-foreground",
              "hover:border-[#D8902F]",
              "focus:outline-none focus:ring-2 focus:ring-[#D8902F]",
              "max-h-32",
              isPending && "opacity-50"
            )}
            disabled={isPending}
          />
        </div>

        <Button
          onClick={handleSend}
          disabled={!message.trim() || isPending}
          size="icon"
          className="flex-shrink-0 bg-[#D8902F] hover:bg-[#D8902F]/90 text-white"
        >
          {isPending ? (
            <Loader2 className="h-5 w-5 animate-spin" />
          ) : (
            <Send className="h-5 w-5" />
          )}
        </Button>
      </div>
    </div>
  );
}
